import React from "react";
import imagemAparelhos from "../../img/imagem-aparelhos.jpg";
import imagemRespiratorios from "../../img/imagem-respiratorios.jpg";
import imagemHomeCare from "../../img/imagem-home-care.jpg";
import { useTheme } from "../../contexts/ThemeContext";
import { CITIES_DATA } from "../../data/citiesData";

// transforma objeto em array
const citiesArray = Object.values(CITIES_DATA);

// função utilitária para filtrar cidades por serviço
const getCitiesByService = (cities, serviceKey) =>
  cities.filter(city => city[serviceKey] === true);

const Services = () => {
  const { domains } = useTheme();

  const services = [
    {
      title: "Aparelhos Auditivos",
      link: domains.auditivo,
      linkText: "clique aqui e confira →",
      description: "Não deixe que a perda auditiva limite a sua vida.",
      imageUrl: imagemAparelhos,
      gradient: "linear-gradient(to top, rgba(107,33,168,0.9), transparent)",
      color: "#F982FF",
      serviceKey: "aud",
    },
    {
      title: "Equipamentos Respiratórios",
      link: domains.respiratorio,
      linkText: "clique aqui e confira →",
      description:
        "Durma utilizando nossos equipamentos originais e de última geração.",
      imageUrl: imagemRespiratorios,
      gradient: "linear-gradient(to top, rgba(22,163,74,0.9), transparent)",
      color: "#9FFF82",
      serviceKey: "cpap",
    },
    {
      title: "Home Care",
      link: domains.homecare,
      linkText: "clique aqui e confira →",
      description: "Cuide da sua saúde sem precisar sair de casa.",
      imageUrl: imagemHomeCare,
      gradient: "linear-gradient(to top, rgba(12,74,110,0.9), transparent)",
      color: "#82C7FF",
      serviceKey: "home",
    },
  ];

  return (
    <section className="max-w-7xl mx-auto grid md:grid-cols-3 gap-4 mb-16 mt-24">
      {services.map((service, index) => {
        const serviceCities = getCitiesByService(
          citiesArray,
          service.serviceKey
        );

        return (
          <a
            key={index}
            href={service.link}
            rel="noopener noreferrer"
            className="relative rounded-2xl overflow-hidden shadow-lg group hover:scale-[1.02] transition-transform h-[550px] block m-4 sm:m-0"
          >
            {/* Imagem de fundo */}
            <div
              className="absolute inset-0 bg-cover bg-center z-0"
              style={{ backgroundImage: `url(${service.imageUrl})` }}
            />

            {/* Degradê */}
            <div
              className="absolute inset-x-0 bottom-0 h-2/5 z-10 transition-all duration-300 group-hover:h-3/4"
              style={{ background: service.gradient }}
            />

            {/* Conteúdo */}
            <div className="absolute bottom-0 left-0 right-0 py-6 z-20 text-white flex flex-col h-full justify-end">
              {/* Título */}
              <div className="px-12">
                <h2 className="text-lg font-bold drop-shadow-md mb-5">
                  {service.title}
                </h2>
                <p
                  className="text-sm mt-1 hover:underline inline-block"
                  style={{ color: service.color }}
                >
                  {service.linkText}
                </p>
              </div>

              {/* Carrossel de cidades */}
              {serviceCities.length > 0 && (
                <div className="relative w-full overflow-hidden mt-4">
                  <div className="flex gap-2 animate-slide">
                    {[...serviceCities, ...serviceCities].map((city, i) => (
                      <a
                        key={`${city.id}-${i}`}
                        href={`${service.link}/city/${city.id}`}
                        className="flex-shrink-0 text-sm px-4 py-1.5 rounded-full 
                                   bg-white/20 backdrop-blur-sm shadow-lg 
                                   hover:bg-white hover:text-gray-800 transition-colors"
                      >
                        {city.shortName}
                      </a>
                    ))}
                  </div>
                </div>
              )}

              {/* Descrição */}
              <p className="text-xs text-gray-400 mt-8 pt-1 px-12 min-h-[4rem]">
                {service.description}
              </p>
            </div>
          </a>
        );
      })}
    </section>
  );
};

export default Services;